import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-gradient-to-r from-garden-dark via-[#1e3d25] to-garden-dark text-white py-2 px-3 sticky top-0 z-50 shadow-md border-b border-white/10" data-id="element-210">
      <div className="max-w-4xl mx-auto flex flex-row flex-nowrap justify-center items-center gap-2 sm:gap-6 text-[10px] sm:text-sm font-semibold font-sans whitespace-nowrap" data-id="element-211">
        <div className="flex items-center text-earth-light/90" data-id="element-212">
          <span className="mr-1 sm:mr-2" data-id="element-213">⏳</span>
          <span className="hidden sm:inline uppercase tracking-wider" data-id="element-214">
            OFERTA EXPIRA EN:{' '}
          </span>
          <span className="sm:hidden uppercase tracking-wider" data-id="element-215">EXPIRA: </span>
          <span className="ml-1 sm:ml-2 font-mono text-xs sm:text-base bg-white/10 backdrop-blur-sm border border-white/20 text-white px-1.5 sm:px-2 py-0.5 rounded-md shadow-inner" data-id="element-216">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>
        <div className="flex items-center text-earth-light animate-pulse" data-id="element-217">
          <span className="mr-1 sm:mr-2" data-id="element-218">🔥</span>
          <span className="uppercase tracking-wider" data-id="element-219">CUPOS LIMITADOS</span>
        </div>
      </div>
    </div>;
}